/*
 * The execution of this bundle is render-blocking. It contains initialization code
 * that inline scripts on the pages rely upon. We don't want that and we eventually want to get rid
 * of this bundle (and the inline scripts).
 *
 * In general, we want to know the dependencies of our pages, so their dependencies should be defined
 * explicitly in the respective page's bundle. If you *really* need to have things globally on every
 * Cadenza page, consider adding them to the "base" bundle: The execution of that bundle is deferred,
 * i.e. it's not render-blocking.
 */

// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- We do not have a Webpack resolve alias for that.
import '../css/base.css';

// public path and polyfills need to be setup first.
import 'cadenza/public-path';
import 'cadenza/polyfills';

import $ from 'jquery';
import { logger } from '@disy/lib/logging';
import { applyThemeProperties } from 'cadenza/theming-api';
import { on } from '@disy/lib/event-util';
import { subscribeToEvent } from 'cadenza/integration/post-message';
import { getDisyNamespace } from '@disy/lib/disy';
import { WebAnalyticsApi } from 'cadenza/web-analytics/web-analytics-api';

document.documentElement.classList.toggle('supports-at-scope', typeof CSSScopeRule !== 'undefined');

const Disy = getDisyNamespace();

applyThemeProperties(Disy.theme);

Object.assign(Disy, {
  logger,
  initializeNavigation: () => {
    // If the start page is loaded, we need to initialize navigation.
    const expandNavigator = isExpandNavigator();
    if (isStartPage() || isProjectStartPage() || expandNavigator) {
      importAndInitializeNavigator(expandNavigator);
      return;
    }

    // Otherwise we initialize navigation on the first click of the navigationTrigger button.
    // After the initialization we need to programmatically click on the button one more time
    // because only then will the click event responsible for showing navigation be triggered.
    const navigationTrigger = document.getElementById('navigationTrigger');
    if (navigationTrigger) {
      on(
        navigationTrigger,
        'click',
        () => importAndInitializeNavigator(true),
        { once: true });
    }

    const unsubscribe = subscribeToEvent('expandNavigator', ({ detail: { expandNavigator } }) => {
      if (expandNavigator) {
        unsubscribe();
        importAndInitializeNavigator(true);
      }
    });
  },
  webAnalyticsApi: new WebAnalyticsApi(),
});

function isStartPage () {
  const page = document.querySelector('.d-page');
  return page?.matches('.welcome-page');
}

function isProjectStartPage () {
  return document.querySelector('.d-page')?.matches('.project-start-page');
}

function isExpandNavigator () {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('expandNavigator') === 'true';
}

// We return a promise which is finished once the navigation is initialized.
async function importAndInitializeNavigator (toggleState) {
  // check if navigation is already initialized to prevent multiple instances of it
  // aria-describedby is set by initializeNavigation function
  if (!$('#navigationTrigger').attr('aria-describedby')) {
    const { getNavigatorController } = await import('cadenza/navigator/navigator-controller');
    await getNavigatorController(toggleState).initialize();
  }
}

if (Disy.debug) {
  logger.enableAll(false); // do not persist the log level in localStorage
}

// Make jQuery globally available for inline scripts (yes, they're bad)
window.$ = $;
window.jQuery = $;
